import React, { Component } from 'react';
import "../../style/common.css";

export class Spinner extends Component {

    componentWillUnmount() {
        console.log("unmount");
    }

    render() {
        console.log("loading spinner");
        return <div className="lds-spinner"><div/><div/><div/><div/><div/><div/><div/><div/><div/><div/><div/><div/></div>
    };
}